import React from 'react';
import { listTypes, useMatchData } from "../../utils";

const MatchInfo = () => {
  const { listType, venue, leagueMatchTitle, competition } = useMatchData();
  if (listType !== listTypes.matches) {
    return null;
  }

  const { name } = venue || {};

  return (
    <div className="mls-o-match-strip__match-info">
      <p className="mls-o-match-strip__match-title">{leagueMatchTitle ? leagueMatchTitle : competition?.name}</p>
      <p className="mls-o-match-strip__venue">{name}</p>
    </div>
  );
};

export default MatchInfo;
